import { listOrganizations } from '../thunks/organizations';
import { handleFulfilled, handlePending, handleRejected } from './utils';

export const organizationsReducers = (builder) => {
  // list organizations of auth users member with
  builder
    .addCase(listOrganizations.fulfilled, (state, action) => handleFulfilled(state, 'organizations', action))
    .addCase(listOrganizations.pending, (state) => handlePending(state, 'organizations'))
    .addCase(listOrganizations.rejected, (state) => handleRejected(state, 'organizations'));
};
